import { IState } from 'core/types';

export const getEvent = ({ event: { event } }: IState) => event;
export const getIsEventLoading = ({ event: { isEventLoading } }: IState) => isEventLoading;
